import React from "react";
import { Box, styled } from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { PageHeader } from "components/page-header/page-header.component";
import { UploadPhysicianFormModal } from "components/upload-physician-form-modal/upload-physician-form-modal.component";

const UploadFormContentWrapper = styled(Box, {
  maxWidth: "708px",
  width: "100%",
  padding: 0,
  "& button": {
    width: "100%",
    maxWidth: "325px",
    height: "auto",
    minHeight: "48px",
    justifyContent: "center",
  },
  "@mobile": {
    "& button": {
      maxWidth: "none",
    },
  },
});

export const PhysicalResultsUploadFormPage = () => {
  usePageViewAnalytics({
    screen_name: "Physician Results Form - Upload",
  });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: "STR_PHYSICIAN_RESULTS_FORM" }));

  return (
    <PageContentWrapper>
      <PageHeader
        variant="sub-page"
        mobileBand="green"
        headingText={formatMessage({ id: "STR_PHYSICIAN_RESULTS_FORM" })}
      />
      <UploadFormContentWrapper>
        <Masonry
          rootNodeId={MASONRY.ROOT_NODE_ID_PHYSICIAN_RESULTS_UPLOAD_FORM}
        />
      </UploadFormContentWrapper>
      <UploadPhysicianFormModal />
    </PageContentWrapper>
  );
};
